<template lang="pug">
  .sidebar__menu-item(
    v-if="showItem(item)"
    :class="{ 'sidebar__menu-item--active': isActive(item), 'sidebar__menu-item--togglable': togglable }"
    @click="onClick(item)")
    svg.sidebar__menu-item-icon
      use(:xlink:href="`/svg/sprite.svg#${item.icon}`")
    span {{ item.title | translate }}
    .sidebar__menu-item-toggler(
      v-if="togglable")
      i.i-arrow-down

</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

export default {
  name: 'FarmSidebarItem',

  mixins: [adaptationMixin],

  props: {
    item: Object,
    togglable: Boolean
  },

  methods: {
    isActive (item) {
      return this.$route.path
        .includes(item.path)
    },

    showItem (item) {
      if (this.isDesktop) {
        return item.screen.includes('desktop')
      }
      if (this.isTablet) {
        return item.screen.includes('tablet')
      }
      if (this.isMobile) {
        return item.screen.includes('mobile')
      }
    },

    onClick (item) {
      if (item.path === 'planning') {
        this.$store.dispatch('planning/planningLoadData')
      }
      this.$emit('click', item)
    }
  }
}
</script>
